/* Cartaanima theme interactions: header, mega menu, drawer, search, announcement rotation,
   product gallery / quantity / variants, collection sort. No dependencies. */
(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return String(cents / 100);
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Header ---------- */
  function initHeader(root) {
    if (root.dataset.ctaInit) return;
    root.dataset.ctaInit = '1';
    var triggers = root.querySelectorAll('[data-cta-mega-trigger]');
    var panels = root.querySelectorAll('[data-cta-mega]');
    var desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');

    function closeAll() {
      panels.forEach(function (p) { p.hidden = true; });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    function open(id) {
      closeAll();
      var panel = root.querySelector('[data-cta-mega="' + id + '"]');
      var trigger = root.querySelector('[data-cta-mega-trigger="' + id + '"]');
      if (panel) panel.hidden = false;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    triggers.forEach(function (t) {
      var id = t.getAttribute('data-cta-mega-trigger');
      t.addEventListener('mouseenter', function () { if (desktop.matches) open(id); });
      t.addEventListener('click', function (e) {
        if (t.getAttribute('aria-expanded') === 'true') return; // second click follows the link
        e.preventDefault();
        open(id);
      });
    });
    root.querySelectorAll('.cta-nav__item:not([data-cta-mega-trigger])').forEach(function (a) {
      a.addEventListener('mouseenter', closeAll);
    });
    root.addEventListener('mouseleave', function () { if (desktop.matches) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });

    // Search
    var searchToggle = root.querySelector('[data-cta-search-toggle]');
    var search = root.querySelector('[data-cta-search]');
    if (searchToggle && search) {
      searchToggle.addEventListener('click', function () {
        closeAll();
        search.hidden = !search.hidden;
        if (!search.hidden) { var i = search.querySelector('input[type=search]'); if (i) i.focus(); }
      });
    }

    // Mobile drawer
    var drawer = root.querySelector('[data-cta-drawer]');
    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
    }
    root.querySelectorAll('[data-cta-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!drawer) return;
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    root.querySelectorAll('[data-cta-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  }

  /* ---------- Announcement rotation ---------- */
  function initRotate(root) {
    if (root.dataset.ctaInit) return;
    root.dataset.ctaInit = '1';
    var items = root.querySelectorAll('.cta-ann__item');
    var secs = parseInt(root.getAttribute('data-cta-rotate'), 10) || 0;
    if (items.length < 2 || secs <= 0) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, secs * 1000);
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    if (root.dataset.ctaInit) return;
    root.dataset.ctaInit = '1';
    var moneyEl = root.querySelector('[data-cta-money-format]');
    var moneyFormat = moneyEl ? JSON.parse(moneyEl.textContent) : '${{amount}}';

    // Gallery
    var gallery = root.querySelector('[data-cta-gallery]');
    var slides = gallery ? gallery.querySelectorAll('.cta-gallery__slide') : [];
    var thumbs = gallery ? gallery.querySelectorAll('[data-cta-thumb]') : [];
    var counter = gallery ? gallery.querySelector('[data-cta-counter]') : null;
    var index = gallery ? parseInt(gallery.getAttribute('data-index'), 10) || 0 : 0;
    function show(i) {
      if (!slides.length) return;
      index = (i % slides.length + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }
    if (gallery) {
      var prev = gallery.querySelector('[data-cta-prev]');
      var next = gallery.querySelector('[data-cta-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-cta-thumb'), 10)); });
      });
      // Swipe on touch
      var main = gallery.querySelector('.cta-gallery__main');
      var x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
    }

    // Buy box
    var buy = root.querySelector('[data-cta-buy]');
    var qtyInput = root.querySelector('[data-cta-qty-input]');
    var labelEl = root.querySelector('[data-cta-buy-label]');
    var submit = buy ? buy.querySelector('[type="submit"]') : null;
    var price = buy ? parseInt(buy.getAttribute('data-price'), 10) : 0;
    var available = submit ? !submit.disabled : true;
    function updateLabel() {
      if (!buy || !labelEl) return;
      if (!available) { labelEl.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out'; return; }
      var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      labelEl.textContent = (buy.getAttribute('data-label') || '').replace('[price]', formatMoney(price * q, moneyFormat));
    }
    root.querySelectorAll('[data-cta-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-cta-qty'), 10));
        qtyInput.value = v;
        updateLabel();
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', updateLabel);

    // Variants
    var picker = root.querySelector('[data-cta-variants]');
    if (picker) {
      var json = picker.querySelector('[data-cta-variant-json]');
      var variants = json ? JSON.parse(json.textContent) : [];
      picker.addEventListener('change', function () {
        var selected = [];
        picker.querySelectorAll('.cta-variants__group').forEach(function (g) {
          var c = g.querySelector('input:checked');
          selected.push(c ? c.value : null);
        });
        var v = variants.find(function (vv) {
          return vv.options.every(function (o, i) { return o === selected[i]; });
        });
        var idInput = root.querySelector('[data-cta-variant-id]');
        if (!v) {
          available = false;
          if (submit) { submit.disabled = true; submit.setAttribute('aria-disabled', 'true'); }
          if (labelEl) labelEl.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'Unavailable';
          return;
        }
        if (idInput) idInput.value = v.id;
        price = v.price;
        available = v.available;
        if (buy) buy.setAttribute('data-price', v.price);
        if (submit) {
          submit.disabled = !v.available;
          if (v.available) submit.removeAttribute('aria-disabled'); else submit.setAttribute('aria-disabled', 'true');
        }
        var priceEl = root.querySelector('[data-cta-price]');
        if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
        var cmp = root.querySelector('[data-cta-compare]');
        if (cmp) {
          cmp.hidden = !(v.compare_at_price && v.compare_at_price > v.price);
          if (!cmp.hidden) cmp.textContent = formatMoney(v.compare_at_price, moneyFormat);
        }
        if (v.featured_media && slides.length) {
          slides.forEach(function (s, n) { if (String(s.getAttribute('data-media-id')) === String(v.featured_media.id)) show(n); });
        }
        var url = root.getAttribute('data-url');
        if (url && window.history.replaceState) window.history.replaceState({}, '', url + '?variant=' + v.id);
        updateLabel();
      });
    }
  }

  /* ---------- Collection sort ---------- */
  function initSort(select) {
    if (select.dataset.ctaInit) return;
    select.dataset.ctaInit = '1';
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-cta-header]').forEach(initHeader);
    scope.querySelectorAll('[data-cta-rotate]').forEach(initRotate);
    scope.querySelectorAll('[data-cta-product]').forEach(initProduct);
    scope.querySelectorAll('[data-cta-sort]').forEach(initSort);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Policy page: table of contents open on desktop, collapsed on mobile */
(function () {
  function initToc() {
    var wide = window.matchMedia('(min-width: 990px)').matches;
    document.querySelectorAll('[data-cta-toc]').forEach(function (d) { d.open = wide; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initToc); else initToc();
  document.addEventListener('shopify:section:load', initToc);
})();
